// Module
var code = `<button class="{{ generateReportController.btnStyle }} clear" ng-click="generateReportController.report()"> <i class="fa fa-file-text-o" aria-hidden="true"></i> <span> {{ 'Generic.Report' | translate }}</span> </button> `;
// Exports
module.exports = code;